import { render, staticRenderFns } from "./ItemQuestionName.vue?vue&type=template&id=480e2e05"
import script from "./ItemQuestionName.vue?vue&type=script&lang=js"
export * from "./ItemQuestionName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports